import React from 'react'

import printJS from 'print-js'

import { usePdfOptionsFormActions } from '../_form/PdfOptionsFormHandler'

export const usePrintPdf = (title, noMargin) => {
  const [loading, setLoading] = React.useState(false)
  const { handleChange } = usePdfOptionsFormActions()

  const onStart = () => {
    setLoading(true)
    if (handleChange) handleChange('preview', false)
  }

  const onStop = () => {
    setLoading(false)
    if (handleChange) handleChange('preview', true)
  }

  const print = () => {
    onStart()
    setTimeout(
      () =>
        printJS({
          documentTitle: title,
          onLoadingStart: () => onStart(),
          onLoadingEnd: () => onStop(),
          onPrintDialogClose: () => onStop(),
          style: `
            ${noMargin ? '@media print {body {margin: -1px; } }' : ''}
            @font-face {
              font-family: 'vivo_typelight';
              src: url('/pdfs/vivo/font/VivoTypeLight.woff') format('woff');
              font-weight: normal;
              font-style: normal;
            };
            @font-face {
              font-family: 'vivo_typebold';
              src: url('/pdfs/vivo/font/VivoTypeBold.woff') format('woff');
              font-weight: bold;
              font-style: normal;
            };
            box-sizing: border-box;
            @media print {
              .pdf-avoid-break, .gallery img, .gallery-images > div {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }
            }
          `,
          printable: 'pdfPage',
          type: 'html',
          scanStyles: false,
          targetStyles: ['*']
        }),
      600
    )
  }

  return [loading, print]
}
